// extracted by mini-css-extract-plugin
export default {"modal":"mui-modal_modal__Oj+jJ","paper":"mui-modal_paper__4v5TX","header":"mui-modal_header__s1q2b","closeButton":"mui-modal_closeButton__MqL2r"};